/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppSolutionAssociationVerificationInconclusiveReason } from './WhatsAppSolutionAssociationVerificationInconclusiveReason';
import type { WhatsAppSolutionAssociationVerificationSource } from './WhatsAppSolutionAssociationVerificationSource';
/**
 * Verification for which no conclusive Meta evidence is available.
 */
export type WhatsAppSolutionAssociationInconclusive = {
    /**
     * Meta signal used to classify the solution association.
     */
    source: WhatsAppSolutionAssociationVerificationSource;
    /**
     * Solution identifier expected for this onboarding attempt.
     */
    expectedSolutionId: string;
    /**
     * Whether the expected solution association should be present.
     */
    expectedPresent: boolean;
    /**
     * ISO timestamp when the evidence was checked.
     */
    checkedAt: string;
    /**
     * Evidence classification.
     */
    status: WhatsAppSolutionAssociationInconclusive.status;
    /**
     * Safe reason verification could not reach a conclusion.
     */
    reason: WhatsAppSolutionAssociationVerificationInconclusiveReason;
};
export namespace WhatsAppSolutionAssociationInconclusive {
    /**
     * Evidence classification.
     */
    export enum status {
        INCONCLUSIVE = 'inconclusive',
    }
}

